export default __webpack_public_path__ + "static/media/loading.6d78a878.svg";